import { Avatar, Box, Button, Flex, Heading, Text } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { Link } from 'react-router-dom';

interface Props {
  client: {
    fullName: string;
    createdAt: string;
  };
}

function Header({ client: { fullName, createdAt } }: Props) {
  return (
    <Flex h="82" p={4} borderBottom="1px" borderColor="gray.200" align="center">
      <Avatar name={fullName} />
      <Box flex={1} px={3}>
        <Heading as="h5" size="sm" mb={1}>
          {fullName}
        </Heading>
        <Text fontSize="sm" color="gray.500">
          Client since {moment(createdAt).format('ll')}
        </Text>
      </Box>
      <Button as={Link} to="edit" variant="ghost">
        <FontAwesomeIcon icon={['fal', 'user-pen']} size="lg" />
      </Button>
    </Flex>
  );
}

export default Header;
